export default {
  fetchURL: 'https://berkimelinda.hu/wp/wp-json/wp/v2'
};



// WEBPACK FOOTER //
// ./src/config.js